import { ShoppingCartItxDto } from "src/api/customer";

export const getItemArray = (cart: ShoppingCartItxDto) => cart 
    ? Array.from(cart.shoppingCartSellerItemGroupItxes).flatMap(group => Array.from(group.items))
    : [];

export const hasChangedItems = (cart: ShoppingCartItxDto) => 
    getItemArray(cart).some(item => item.hasChanged && item.productItx.productState === "ACTIVE");

export const hasUnavailableItems = (cart: ShoppingCartItxDto) =>
    getItemArray(cart).some(item => item.productItx.productState !== "ACTIVE");

export const isProductInCart = (cart: ShoppingCartItxDto, productId: number) =>
    getItemArray(cart).some(item => item.productItx.id == productId);

export const getUnavailableIDProducts = (cart: ShoppingCartItxDto): number[] | [] => {
    return getItemArray(cart).filter(item => item.productItx.productState !== "ACTIVE").map(item => item.productItx.id) ?? []
}